// ja strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "初月{price}から",
  "pricing.title": "好きな声でカバーを作ろう",
  "pricing.subtitle":
    "カバー作成とダウンロードが無制限、9.3万以上のボイスがすべて使えます。いつでも解約できます。",
  "pricing.trialLinkInvalid":
    "この無料トライアルのリンクは別のアカウント用か、期限が切れています。通常のお支払い画面を表示しています。",

  "pricing.basic.subtitle": "カバーを作る方に",
  "pricing.creator.subtitle": "動画や自分のボイスを作る方に",
  "pricing.power.subtitle": "たくさん使う方・開発者に",
  "pricing.badge.popular": "いちばん人気",

  "pricing.feature.unlimitedCovers": "カバー作成が無制限",
  "pricing.feature.download": "カバー・ボーカル・伴奏をダウンロード",
  "pricing.feature.library": "ボイスライブラリがすべて使える",
  "pricing.feature.tts": "テキスト読み上げ",
  "pricing.feature.duets": "デュエット",
  "pricing.feature.credits": "クレジットの有効期限なし",
  "pricing.feature.train": "ボイスを無制限に学習",
  "pricing.feature.videos": "シェア用の動画：Marble Runと歌詞動画",
  "pricing.feature.coins50": "毎月50枚の動画コイン",
  "pricing.feature.priority": "優先処理（12時間あたり250件）",
  "pricing.feature.coinsUnlimited": "動画コインが無制限",
  "pricing.feature.api": "毎月$25分のAPIクレジット",

  "pricing.compareAll": "すべての機能を比較",
  "pricing.trust.cancel": "いつでも解約OK、作った作品はそのまま",
  "pricing.trust.stripe": "Stripeによる安全なお支払い",
  "pricing.trust.currency": "お住まいの地域の通貨で表示",

  "pricing.compare.title": "プランを比較",
  "pricing.compare.noPlan": "プランなし",
  "pricing.compare.browse": "すべてのボイスを閲覧・試聴",
  "pricing.compare.covers": "カバー作成",
  "pricing.compare.downloads": "ダウンロード",
  "pricing.compare.ttsDuets": "テキスト読み上げとデュエット",
  "pricing.compare.song": "AIで曲を生成",
  "pricing.compare.train": "自分のボイスを学習",
  "pricing.compare.videos": "動画（Marble Run、歌詞動画）",
  "pricing.compare.priority": "優先処理",
  "pricing.compare.api": "APIクレジット",
  "pricing.compare.unlimited": "無制限",
  "pricing.compare.coins50": "毎月50コイン",
  "pricing.compare.priorityLimit": "12時間あたり250件",
  "pricing.compare.apiAmount": "毎月$25",

  "pricing.faq.title": "よくある質問",
  "pricing.faq.noPlan.q": "プランなしで何ができますか？",
  "pricing.faq.noPlan.a":
    "Jammableのすべてのボイスを閲覧・試聴できます。カバーの作成とダウンロード、テキスト読み上げ、デュエットにはプランが必要です。",
  "pricing.faq.basic.q": "Basicプランには何が含まれますか？",
  "pricing.faq.basic.a":
    "Basicプランでは、カバー作成とダウンロードが無制限、Jammableのボイスライブラリをすべて利用でき、テキスト読み上げとデュエットも使えます。クレジットに有効期限はありません。",
  "pricing.faq.creator.q": "CreatorプランとBasicプランの違いは？",
  "pricing.faq.creator.a":
    "CreatorプランはBasicの全機能に加えて、ボイスを無制限に学習でき、シェア用の動画を作成でき、毎月50枚のMarble Runコインが付きます。",
  "pricing.faq.power.q": "Powerプランの特長は？",
  "pricing.faq.power.a":
    "PowerはCreatorの全機能に加えて、優先処理（12時間あたり250件）、Marble Runコインが無制限、毎月$25分のAPIクレジットが付いた、本格的なクリエイター向けのプランです。",
  "pricing.faq.cancel.q": "いつでも解約できますか？",
  "pricing.faq.cancel.a":
    "はい、いつでも解約できます。特典は現在の請求期間の終わりまで使えます。",
  "pricing.faq.change.q": "プランの変更はできますか？",
  "pricing.faq.change.a":
    "もちろんです。アップグレードもダウングレードもいつでもでき、特典はそれに合わせて切り替わります。",

  "pricing.card.perYear": "年額（月あたり約{price}）",
  "pricing.card.firstMonthThen": "初月、以降は月額{price}",
  "pricing.card.perMonth": "/月",
  "pricing.card.startFor": "{price}で始める",
  "pricing.card.everythingIn": "{plan}の全機能に加えて",
  "pricing.cta.get": "{plan}に登録",
  "pricing.cta.yourPlan": "現在のプラン",
  "pricing.cta.manage": "プランを管理",
  "pricing.cta.upgradeTo": "{plan}にアップグレード",
  "pricing.cta.updated": "サブスクリプションを更新しました！",
  "pricing.error.generic":
    "エラーが発生しました。サポートまでお問い合わせください。",
  "pricing.seo.title": "料金プラン | Jammable",
  "pricing.seo.description":
    "好きな声でAIカバーを作れるJammableの料金プラン。カバー作成とダウンロードが無制限、9.3万以上のボイス。お住まいの地域の通貨で表示、いつでも解約できます。",
};

export default pricing;
